import React from "react";
import TapToZoomIcon from "../../icons/tap-to-zoom.svg";
import { graphql, useStaticQuery } from "gatsby";
import classNames from "classnames";

const TapToZoom = ({ showTapToZoom }) => {
  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels {
        tapToZoom
      }
    }
  `);
  return (
    <div className={classNames("tap-to-zoom", !showTapToZoom && "tap-to-zoom--opacity")}>
      <TapToZoomIcon />
      {labelManagerLabels.tapToZoom}
    </div>
  );
};

export default TapToZoom;
